module.exports = __webpack_public_path__ + "static/media/20.bd24d94d.mp3";